export default '•'
